import { z } from 'zod';
import { dashboardKpiQuerySchema } from './kpi.js';
export const ANALYTICS_METRIC_KEYS = [
    'reply_rate',
    'bounce_rate',
    'win_rate',
    'pipeline_value',
];
export const ANALYTICS_METRIC_LABELS = {
    reply_rate: 'Reply rate',
    bounce_rate: 'Bounce rate',
    win_rate: 'Win rate (deals)',
    pipeline_value: 'Pipeline waarde (open)',
};
export const analyticsRangeQuerySchema = dashboardKpiQuerySchema;
export const analyticsGoalSchema = z.object({
    project_id: z.string().uuid(),
    metric_key: z.enum(ANALYTICS_METRIC_KEYS),
    target_value: z.number().min(0),
    direction: z.enum(['min', 'max']).default('min'),
});
export const analyticsGoalPatchSchema = analyticsGoalSchema
    .partial()
    .omit({ project_id: true, metric_key: true });
//# sourceMappingURL=analytics.js.map